var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message failure"},[_c('v-alert',{attrs:{"show":"","type":"error"}},[_vm._t("default",function(){return [_vm._v("Something went terribly wrong, please try again")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }